import { ArrowUpRight, Zap } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { AFFILIATE_LINKS } from "../lib/affiliates";
import { trackAffiliateClick } from "../lib/analytics";

const PARTNERS = [
    { id: "taxually", url: AFFILIATE_LINKS.taxually },
    { id: "quaderno", url: AFFILIATE_LINKS.quaderno },
    { id: "avalara", url: AFFILIATE_LINKS.avalara },
];

export default function AffiliateCard() {
    const { t } = useI18n();

    return (
        <section data-testid="affiliate-card-section" className="max-w-7xl mx-auto px-4 sm:px-6 pb-12">
            <div className="rounded-2xl bg-[#0F172A] text-white p-6 sm:p-10 relative overflow-hidden">
                <div
                    className="absolute inset-0 opacity-30 pointer-events-none [mask-image:radial-gradient(ellipse_at_right,black,transparent_70%)]"
                    style={{
                        backgroundImage:
                            "linear-gradient(to right, rgba(16,185,129,0.18) 1px, transparent 1px), linear-gradient(to bottom, rgba(16,185,129,0.18) 1px, transparent 1px)",
                        backgroundSize: "32px 32px",
                    }}
                />
                <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                    <div>
                        <div className="inline-flex items-center gap-2 rounded-full bg-[#10B981]/15 text-[#10B981] px-3 py-1 text-xs font-semibold tracking-wider uppercase">
                            <Zap className="h-3.5 w-3.5" />
                            {t("affiliateCard.recommended")}
                        </div>
                        <h3 className="font-display mt-4 text-2xl sm:text-3xl font-bold text-white">
                            {t("affiliateCard.title")}
                        </h3>
                        <p className="mt-3 text-slate-300 text-base leading-relaxed max-w-xl">
                            {t("affiliateCard.intro")}
                        </p>
                        <a
                            data-testid="affiliate-card-cta"
                            href={AFFILIATE_LINKS.cardCta}
                            target="_blank"
                            rel="noopener noreferrer sponsored"
                            onClick={() => trackAffiliateClick("quaderno", "card-cta")}
                            className="mt-6 inline-flex items-center gap-2 rounded-md bg-[#10B981] px-5 py-3 text-sm font-semibold text-white shadow-sm hover:bg-emerald-600 hover:-translate-y-px transition-all"
                        >
                            {t("affiliateCard.getStarted")}
                            <ArrowUpRight className="h-4 w-4" />
                        </a>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                        {PARTNERS.map((p) => (
                            <a
                                key={p.id}
                                href={p.url}
                                target="_blank"
                                rel="noopener noreferrer sponsored"
                                onClick={() => trackAffiliateClick(p.id, `partner-${p.id}`)}
                                data-testid={`partner-${p.id}`}
                                className="rounded-lg border border-white/10 bg-white/5 p-4 hover:bg-white/10 hover:-translate-y-px transition-all block"
                            >
                                <div className="font-display font-bold text-white inline-flex items-center gap-1.5">
                                    {t(`affiliateCard.partners.${p.id}.name`)}
                                    <ArrowUpRight className="h-3.5 w-3.5 opacity-60" />
                                </div>
                                <div className="mt-1 text-xs text-slate-300 leading-relaxed">
                                    {t(`affiliateCard.partners.${p.id}.desc`)}
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
